import { AspectRatio as AspectRatioPrimitive } from 'radix-ui';
export const AspectRatio = AspectRatioPrimitive.Root;
export type AspectRatioProps = AspectRatioPrimitive.AspectRatioProps;
